// JsFromRoutes CacheKey dfb0c335392a6a134a466403abb46e28
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/employer_reviews'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/employer_reviews/:id'),
}
